var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.slides.length > 0
    ? _c(
        "div",
        {},
        [
          _c(
            "slick",
            {
              ref: "carousel_main",
              staticClass: "product-view__gallery",
              attrs: { options: _vm.galleryOptions },
            },
            _vm._l(_vm.slides, function (slide, index) {
              return _c("div", { staticClass: "gallery-item" }, [
                _c("img", {
                  staticClass: "gallery-item__image",
                  attrs: { src: slide.url, alt: slide.alt },
                }),
              ])
            }),
            0
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }